import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../../_services/langhfre.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-plagiarism-checker',
  templateUrl: './plagiarism-checker.component.html',
  styleUrls: ['./plagiarism-checker.component.scss']
})
export class PlagiarismCheckerComponent implements OnInit, AfterViewInit {
  video_pause: boolean = false;
  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('표절 검사 | 가장 정확한 최첨단 무료 영어 표절 검사 - 트링카');
    this.metaTagService.updateTag({ name: 'description', content: "모든 인터넷과 유, 무료 출판 논문을 통틀어 분야를 막론하고 최대 규모 데이터베이스를 완비한 최고 품질의 표절 검사를 경험해 보세요." });
    this.metaTagService.updateTag({ property: 'og:title', content: '표절 검사 | 가장 정확한 최첨단 무료 영어 표절 검사 - 트링카' });
    this.metaTagService.updateTag({ property: 'og:description', content: '모든 인터넷과 유, 무료 출판 논문을 통틀어 분야를 막론하고 최대 규모 데이터베이스를 완비한 최고 품질의 표절 검사를 경험해 보세요.' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/features/plagiarism-check' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/features/pc-check.jpg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '표절 검사 | 가장 정확한 최첨단 무료 영어 표절 검사 - 트링카' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "모든 인터넷과 유, 무료 출판 논문을 통틀어 분야를 막론하고 최대 규모 데이터베이스를 완비한 최고 품질의 표절 검사를 경험해 보세요." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/features/pc-check.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/features/plagiarism-check' });
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../assets/js/owl.carousel.min.js', function () { });
      $.getScript('../../../assets/js/wisepop.js', function () { });
    }
    
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../../assets/js/home_client_slider.js', function () { });
      $('#closedPopup, #wordPluginPopup').click(function () {
        $('iframe.youtubeVideoForTryDemo').remove()
      });

      $('#VewiVideoSection').click(function () {
        if (!$('#iframe').length) {
          $('#iframeHolder').html('<iframe class="youtubeVideoForTryDemo" id="iframe" src="https://www.youtube.com/embed/Mc_EZXIzvFU" width="100%" height="450"></iframe>');
        }
      });

    }
  }
  playPause() {
    var myVideo: any = document.getElementById("myVideo");
    if (myVideo.paused) myVideo.play();
    else myVideo.pause();
    this.video_pause= !this.video_pause;  
  }
  showTab = 1;
  advancePlagiarism(index) {
    this.showTab = index;
  }

  standardshowTab = 2;
  standardPlagiarism(index) {
    this.standardshowTab = index;
  }

  freeshowTab = 1;
  freeScore(index) {
    this.freeshowTab = index;
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }
}
